import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Toaster, toast } from "sonner";

import { describeError, errorMessage } from "./api/errors";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider } from "./auth/AuthContext";
import { NEW_ORDER_TOASTER } from "./components/NewOrderPopup";
import { installBlankFieldGuard } from "./lib/form";
import "./index.css";

// Blocks submitting any form whose required field holds only spaces (see lib/form.ts).
installBlankFieldGuard();

const queryClient = new QueryClient({
  // Any failed query surfaces the backend error message as a toast. Fires once
  // per query (not per failed retry), so it won't spam during the retry below.
  queryCache: new QueryCache({
    onError: (error) => toast.error(errorMessage(error)),
  }),
  // A failed mutation is never silent (XC-05): screens that handle their own errors (an `onError`
  // on the mutation, usually showing the message inline) keep doing so; every other one toasts the
  // server's message here, so a rejected save no longer just re-enables its button.
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.options.onError) return;
      toast.error(describeError(error));
    },
  }),
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <QueryClientProvider client={queryClient}>
    {/* <ReactQueryDevtools /> */}
    <BrowserRouter
    // future={{
    //   v7_startTransition: true,
    //   v7_relativeSplatPath: true,
    // }}
    >
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
    <Toaster
      position="top-center"
      duration={4000}
      richColors
      closeButton
      theme="light"
      expand={false}
      visibleToasts={3}
    />
    {/* New-order popups for pharmacists (components/NewOrderPopup.tsx): top-right, just below the
        app header so its name and Sign out stay usable. */}
    <Toaster
      id={NEW_ORDER_TOASTER}
      position="top-right"
      // Below the app header, which itself sits below the notch (RESP-02).
      offset={{ top: "calc(64px + env(safe-area-inset-top, 0px))", right: 16 }}
      mobileOffset={{ top: "calc(64px + env(safe-area-inset-top, 0px))", right: 16, left: 16 }}
      theme="light"
      expand
      visibleToasts={4}
    />
  </QueryClientProvider>,
  // </StrictMode>,
);
